import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 15px',
    width: '100%'
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 8
    }
  },
  herderTitle: { display: 'flex', flexDirection: 'column', gap: 6 },
  greyText: { fontWeight: 500, color: theme.palette.grey[600] },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    alignItems: 'center'
  },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    color: theme.palette.primary.contrastText,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '20px'
  },
  timeText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 600
  },
  icon: {
    fontSize: 18,
    marginRight: 4,
    color: theme.palette.primary.contrastText
  },

  btn: { marginTop: 16, marginLeft: 16, paddingLeft: 24, paddingRight: 24 },
  btnText: { color: theme.palette.primary.contrastText, fontWeight: 500 },
  bottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  left: { display: 'flex' },
  label: { color: theme.palette.text.primary, fontSize: 14 },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.background.default
  },
  expiryContainer: {
    background: theme.palette.secondary.main,
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px',
    gap: 8
  }
}))
export default useStyles
